import { render, staticRenderFns } from "./FollowupsBulkBar.vue?vue&type=template&id=5739502a&scoped=true"
import script from "./FollowupsBulkBar.vue?vue&type=script&lang=js"
export * from "./FollowupsBulkBar.vue?vue&type=script&lang=js"
import style0 from "./FollowupsBulkBar.vue?vue&type=style&index=0&id=5739502a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5739502a",
  null
  
)

export default component.exports